// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import {
  Input,
  Output,
  EventEmitter,
  Component,
  OnInit,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  AfterViewInit,
  SimpleChange
} from '@angular/core';
import { LoadingStatus } from '@app/core';
import { BehaviorSubject } from 'rxjs';

interface IdOption {
  id: string;
  name: string;
  selected?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-radio-select',
  templateUrl: './radio-select.component.html',
  styleUrls: ['./radio-select.component.scss']
})
export class RadioSelectComponent implements OnDestroy, OnInit, OnChanges {
  @Input() name = '';
  @Input() type = '';
  @Input() classNames = '';
  @Input() selected!: IdOption;
  @Input() options: IdOption[] = [];
  @Input() selectIfOneOption = false;
  @Output() selectOption: EventEmitter<IdOption> = new EventEmitter<IdOption>();

  loading = { status: LoadingStatus.LOADING };
  loading$ = new BehaviorSubject<any>(this.loading);

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {
    this.loading$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.handleOptionsChanged(changes.options);
  }

  handleOptionsChanged(options: SimpleChange) {
    const optionsChanged = options && options.currentValue && options.currentValue !== options.previousValue;

    if (this.selectIfOneOption && optionsChanged) {
      const selected = this.options[0] || {};
      if (selected.id) {
        this.selected = selected;
        this.onSelect(selected);
      }
    }
  }

  onSelect(option: IdOption) {
    this.selectOption.emit(option);
  }

  trackOptions(idx: number) {
    return `option${name}${idx}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/radio-select/radio-select.component.ts